'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var play = function play() {
  return import('@/page/play');
};
var livePlay = function livePlay() {
  return import('@/page/live-play');
};
var playVideo = function playVideo() {
  return import('@/page/play-video');
};
exports.default = [{
  path: '/play',
  name: 'play',
  component: play,
  childred: []
}, {
  path: '/livePlay',
  name: 'livePlay',
  component: livePlay,
  childred: []
}, {
  path: '/playVideo',
  name: 'playVideo',
  component: playVideo,
  childred: []
}];